import { logger } from '../utils';
/**
 * Data server result filter.
 *
 * @param result - The raw data server result.
 * @param rowId - Row id. Defaults to ROW_REF.
 *
 * @public
 * @remarks
 * Centralised filter logic for row operations.
 */
export function dataServerResultFilter(result, rowId = 'ROW_REF') {
    const toRowData = (row) => {
        const tmp = Object.assign(Object.assign({}, row), { [rowId]: row.DETAILS[rowId] });
        delete tmp.DETAILS;
        return tmp;
    };
    const inserts = [];
    const deletes = [];
    const updates = [];
    for (const row of result.ROW) {
        if (!row.DETAILS) {
            continue;
        }
        switch (row.DETAILS.OPERATION) {
            case 'INSERT':
                inserts.push(toRowData(row));
                break;
            case 'MODIFY':
                updates.push(toRowData(row));
                break;
            case 'DELETE':
                deletes.push(toRowData(row));
                break;
            default:
                logger.error(`Unsupported operation type: '${row.DETAILS.OPERATION}'`);
        }
    }
    return { inserts, deletes, updates, SOURCE_REF: result.SOURCE_REF };
}
